import { useState } from "react";
import { Outlet } from "react-router-dom";
import { SideBarLayout } from "../../../components/layouts/SideBarLayout";
import { SideNav } from "../../../apps/_shell/navigation/SideNav";
import { TopNavigationProvider } from "./TopNavigationsProvider";
import localStorageService from "../../../services/local/localStorageService/LocalStorageService";

export const Navigation: React.FC<any> = () => {
  let [isExpanded, setIsExpanded] = useState<boolean>(!localStorageService.hasKey("insight-sidenav-expanded"));
  return (
    <SideBarLayout>
      <SideNav
        onExpandedToggle={function (isExpanded: boolean): void {
          setIsExpanded(isExpanded);
        }}
      />
      <SideBarLayout isExpanded={isExpanded} direction="horizontal">
        <TopNavigationProvider />
        <div className="navigation__content">
          <Outlet />
        </div>
      </SideBarLayout>
    </SideBarLayout>
  );
};
